// Redux Reducers
// More info about explanation of Redux Reducers; https://redux.js.org/basics/reducers

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import home from './home_reducer';
import posts from './posts_reducer';
import work from './work_reducer';
import menus from './menu_reducer';
import btswp from './btswp_reducer';
import options from './options_reducer';
import postImage from './postImage_reducer';

export default combineReducers({
    home,
    work,
    posts,
    menus,
    btswp,
    options,
    postImage,
    router: routerReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.jsx